import customFetch, { simpleFetch } from './customFetch';

export const getCurrentHeroBanner = () => (
  customFetch('/hero-banners?limit=999').then((data) => {
    if (Array.isArray(data)) {
      return data[data.length - 1] || {};
    }

    return [];
  })
);

export const putCurrentHeroBanner = (id, data) => (
  customFetch('/hero-banners', {
    method: 'POST',
    body: JSON.stringify({ ...data, id }),
  })
);

export const postHeroBanner = (data) => (
  customFetch('/hero-banners', {
    method: 'POST',
    body: JSON.stringify(data),
  })
);

export const invalidateCacheHeroBanner = () => (
  simpleFetch('/hero-banners/current/cache', { method: 'DELETE' })
);
